import { render, staticRenderFns } from "./IconReplace.vue?vue&type=template&id=894f1e44&"
import script from "./IconReplace.vue?vue&type=script&lang=js&"
export * from "./IconReplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('894f1e44')) {
      api.createRecord('894f1e44', component.options)
    } else {
      api.reload('894f1e44', component.options)
    }
    module.hot.accept("./IconReplace.vue?vue&type=template&id=894f1e44&", function () {
      api.rerender('894f1e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconReplace.vue"
export default component.exports